export const excelItem = (locationsTable: any[]): any => {
  return [...locationsTable].sort((a: any, b: any) => {
    if (!isNaN(a.code) && !isNaN(b.code)) {
      return a.code - b.code;
    }
    if (a.code < b.code) {
      return -1;
    }
    if (a.code > b.code) {
      return 1;
    }
    return 0;
  });
};
